
import React from 'react';
import { GenericDatePicker } from './GenericDatePicker';
import { DatePicker as MuiDatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';

export interface IDatePickerProps extends DatePickerProps<any, any> {}

export const DatePicker: React.FC<IDatePickerProps> = props => (
  <GenericDatePicker {...props} DatePickerComponent={MuiDatePicker} />
);

export type { DatePickerProps };
